/**
 * Система переводов MaslaXat
 *
 * Языки:
 * - ru: Русский
 * - uz: Ўзбекча (кириллица)
 * - en: English
 *
 * Чтобы добавить перевод:
 * 1. Найдите нужный раздел (login, dashboard, lawyers и т.д.)
 * 2. Добавьте ключ на всех 3 языках
 * 3. Используйте в компоненте: const { t } = useTranslation(); t('section.key')
 */

const translations = {
  // ==================== ОБЩИЕ ====================
  common: {
    ru: {
      appName: 'MaslaXat',
      loading: 'Загрузка...',
      save: 'Сохранить',
      cancel: 'Отмена',
      delete: 'Удалить',
      edit: 'Редактировать',
      search: 'Поиск',
      filter: 'Фильтр',
      all: 'Все',
      yes: 'Да',
      no: 'Нет',
      back: 'Назад',
      next: 'Далее',
      submit: 'Отправить',
      close: 'Закрыть',
      success: 'Успешно',
      error: 'Ошибка',
      warning: 'Предупреждение',
      info: 'Информация',
      noData: 'Нет данных',
      required: 'Обязательное поле',
      optional: 'Необязательно',
    },
    uz: {
      appName: 'МаслаХат',
      loading: 'Юкланмоқда...',
      save: 'Сақлаш',
      cancel: 'Бекор қилиш',
      delete: 'Ўчириш',
      edit: 'Таҳрирлаш',
      search: 'Қидириш',
      filter: 'Филтр',
      all: 'Барчаси',
      yes: 'Ҳа',
      no: 'Йўқ',
      back: 'Орқага',
      next: 'Кейинги',
      submit: 'Юбориш',
      close: 'Ёпиш',
      success: 'Муваффақият',
      error: 'Хатолик',
      warning: 'Огоҳлантириш',
      info: 'Маълумот',
      noData: 'Маълумот йўқ',
      required: 'Мажбурий майдон',
      optional: 'Ихтиёрий',
    },
    en: {
      appName: 'MaslaXat',
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      search: 'Search',
      filter: 'Filter',
      all: 'All',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      close: 'Close',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Information',
      noData: 'No data',
      required: 'Required field',
      optional: 'Optional',
    },
  },

  // ==================== СТРАНИЦА ВХОДА ====================
  login: {
    ru: {
      title: 'MaslaXat',
      subtitle: 'Онлайн юридическая платформа Узбекистана',
      subtitleEn: 'Online Legal Platform of Uzbekistan',
      selectRole: 'Выберите тип входа',

      // Роли
      client: 'Клиент',
      clientSubtitle: 'Получите юридическую помощь',
      lawyer: 'Юрист',
      lawyerSubtitle: 'Предложите свои услуги',
      admin: 'Администратор',
      adminSubtitle: 'Управление платформой',

      // Возможности
      features: 'Возможности:',
      clientFeature1: 'AI-консультант 24/7',
      clientFeature2: 'Проверенные юристы',
      clientFeature3: 'Анализ документов',
      lawyerFeature1: 'Дополнительный доход',
      lawyerFeature2: 'Новые клиенты',
      lawyerFeature3: 'Гибкий график',
      adminFeature1: 'Полный контроль',
      adminFeature2: 'Аналитика',
      adminFeature3: 'Модерация',

      // Кнопки
      loginAs: 'Войти как',
      quickLogin: 'Быстрый вход (тест)',

      // Форма входа
      email: 'Email',
      password: 'Пароль',
      rememberMe: 'Запомнить меня',
      forgotPassword: 'Забыли пароль?',
      login: 'Войти',
      register: 'Регистрация',
      noAccount: 'Нет аккаунта?',
      hasAccount: 'Уже есть аккаунт?',

      // Сообщения
      loginSuccess: 'Вход выполнен успешно',
      loginError: 'Ошибка входа',
      invalidCredentials: 'Неверный email или пароль',

      // Footer
      copyright: '© 2024 MaslaXat. Все права защищены',
    },
    uz: {
      title: 'МаслаХат',
      subtitle: 'Ўзбекистоннинг онлайн юридик платформаси',
      subtitleEn: 'Online Legal Platform of Uzbekistan',
      selectRole: 'Кириш турини танланг',

      // Роли
      client: 'Мижоз',
      clientSubtitle: 'Юридик ёрдам олинг',
      lawyer: 'Юрист',
      lawyerSubtitle: 'Хизматларингизни таклиф қилинг',
      admin: 'Администратор',
      adminSubtitle: 'Платформани бошқариш',

      // Возможности
      features: 'Имкониятлар:',
      clientFeature1: 'AI-маслаҳатчи 24/7',
      clientFeature2: 'Тасдиқланган юристлар',
      clientFeature3: 'Ҳужжатлар таҳлили',
      lawyerFeature1: 'Қўшимча даромад',
      lawyerFeature2: 'Янги мижозлар',
      lawyerFeature3: 'Мослашувчан жадвал',
      adminFeature1: 'Тўлиқ назорат',
      adminFeature2: 'Таҳлил',
      adminFeature3: 'Модерация',

      // Кнопки
      loginAs: 'Сифатида кириш',
      quickLogin: 'Тез кириш (тест)',

      // Форма входа
      email: 'Электрон почта',
      password: 'Парол',
      rememberMe: 'Мени эслаб қол',
      forgotPassword: 'Паролни унутдингизми?',
      login: 'Кириш',
      register: 'Рўйхатдан ўтиш',
      noAccount: 'Ҳисобингиз йўқми?',
      hasAccount: 'Ҳисобингиз борми?',

      // Сообщения
      loginSuccess: 'Кириш муваффақиятли бажарилди',
      loginError: 'Кириш хатоси',
      invalidCredentials: 'Нотўғри email ёки парол',

      // Footer
      copyright: '© 2024 МаслаХат. Барча ҳуқуқлар ҳимояланган',
    },
    en: {
      title: 'MaslaXat',
      subtitle: 'Online Legal Platform of Uzbekistan',
      subtitleEn: 'Online Legal Platform of Uzbekistan',
      selectRole: 'Select login type',

      // Роли
      client: 'Client',
      clientSubtitle: 'Get legal assistance',
      lawyer: 'Lawyer',
      lawyerSubtitle: 'Offer your services',
      admin: 'Administrator',
      adminSubtitle: 'Platform management',

      // Возможности
      features: 'Features:',
      clientFeature1: 'AI Consultant 24/7',
      clientFeature2: 'Verified lawyers',
      clientFeature3: 'Document analysis',
      lawyerFeature1: 'Additional income',
      lawyerFeature2: 'New clients',
      lawyerFeature3: 'Flexible schedule',
      adminFeature1: 'Full control',
      adminFeature2: 'Analytics',
      adminFeature3: 'Moderation',

      // Кнопки
      loginAs: 'Login as',
      quickLogin: 'Quick login (test)',

      // Форма входа
      email: 'Email',
      password: 'Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      login: 'Login',
      register: 'Register',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',

      // Сообщения
      loginSuccess: 'Login successful',
      loginError: 'Login error',
      invalidCredentials: 'Invalid email or password',

      // Footer
      copyright: '© 2024 MaslaXat. All rights reserved',
    },
  },

  // ==================== НАВИГАЦИЯ ====================
  nav: {
    ru: {
      dashboard: 'Главная',
      lawyers: 'Юристы',
      consultations: 'Консультации',
      documents: 'Документы',
      aiChat: 'AI Помощник',
      profile: 'Профиль',
      settings: 'Настройки',
      logout: 'Выход',
      admin: 'Админ панель',
    },
    uz: {
      dashboard: 'Бош саҳифа',
      lawyers: 'Юристлар',
      consultations: 'Консультациялар',
      documents: 'Ҳужжатлар',
      aiChat: 'AI Ёрдамчи',
      profile: 'Профил',
      settings: 'Созламалар',
      logout: 'Чиқиш',
      admin: 'Админ панели',
    },
    en: {
      dashboard: 'Dashboard',
      lawyers: 'Lawyers',
      consultations: 'Consultations',
      documents: 'Documents',
      aiChat: 'AI Assistant',
      profile: 'Profile',
      settings: 'Settings',
      logout: 'Logout',
      admin: 'Admin Panel',
    },
  },

  // ==================== ДАШБОРД ====================
  dashboard: {
    ru: {
      welcome: 'Добро пожаловать',
      totalConsultations: 'Всего консультаций',
      activeConsultations: 'Активные',
      completedConsultations: 'Завершённые',
      pendingConsultations: 'Ожидающие',
      recentActivity: 'Последняя активность',
      quickActions: 'Что хотите сделать?',
      findLawyer: 'Найти юриста',
      askAI: 'Спросить AI',
      uploadDocument: 'Загрузить документ',
      myConsultations: 'Мои записи',
      viewAll: 'Смотреть все консультации',
      aiChats: 'AI Чаты',
      aiDescription: 'Получите бесплатную юридическую консультацию от AI-помощника',
      startChat: 'Начать чат',
    },
    uz: {
      welcome: 'Хуш келибсиз',
      totalConsultations: 'Жами консультациялар',
      activeConsultations: 'Фаол',
      completedConsultations: 'Тугалланган',
      pendingConsultations: 'Кутилаётган',
      recentActivity: 'Сўнгги фаолият',
      quickActions: 'Нима қилмоқчисиз?',
      findLawyer: 'Юрист топиш',
      askAI: 'AI дан сўраш',
      uploadDocument: 'Ҳужжат юклаш',
      myConsultations: 'Менинг ёзувларим',
      viewAll: 'Барча консультацияларни кўриш',
      aiChats: 'AI Чатлар',
      aiDescription: 'AI-ёрдамчидан бепул юридик консультация олинг',
      startChat: 'Чатни бошлаш',
    },
    en: {
      welcome: 'Welcome',
      totalConsultations: 'Total consultations',
      activeConsultations: 'Active',
      completedConsultations: 'Completed',
      pendingConsultations: 'Pending',
      recentActivity: 'Recent activity',
      quickActions: 'What would you like to do?',
      findLawyer: 'Find a lawyer',
      askAI: 'Ask AI',
      uploadDocument: 'Upload document',
      myConsultations: 'My consultations',
      viewAll: 'View all consultations',
      aiChats: 'AI Chats',
      aiDescription: 'Get free legal consultation from AI assistant',
      startChat: 'Start chat',
    },
  },

  // ==================== ЮРИСТЫ ====================
  lawyers: {
    ru: {
      title: 'Юристы',
      subtitle: 'Найдите подходящего специалиста',
      searchPlaceholder: 'Поиск по имени или специализации...',
      filters: 'Фильтры',
      specialization: 'Специализация',
      experience: 'Опыт работы',
      rating: 'Рейтинг',
      price: 'Цена',
      from: 'от',
      years: 'лет',
      consultations: 'консультаций',
      reviews: 'отзывов',
      bookConsultation: 'Записаться',
      viewProfile: 'Профиль',
      online: 'Онлайн',
      offline: 'Оффлайн',
      verified: 'Проверен',
      topRated: 'Топ рейтинг',

      // Специализации
      specFamily: 'Семейное право',
      specCriminal: 'Уголовное право',
      specCivil: 'Гражданское право',
      specBusiness: 'Бизнес право',
      specLabor: 'Трудовое право',
      specProperty: 'Недвижимость',
      specTax: 'Налоговое право',
      specIntellectual: 'Интеллектуальная собственность',
    },
    uz: {
      title: 'Юристлар',
      subtitle: 'Мос мутахассисни топинг',
      searchPlaceholder: 'Исм ёки ихтисослик бўйича қидириш...',
      filters: 'Филтрлар',
      specialization: 'Ихтисослик',
      experience: 'Иш тажрибаси',
      rating: 'Рейтинг',
      price: 'Нарх',
      from: 'дан',
      years: 'йил',
      consultations: 'консультация',
      reviews: 'фикрлар',
      bookConsultation: 'Ёзилиш',
      viewProfile: 'Профил',
      online: 'Онлайн',
      offline: 'Оффлайн',
      verified: 'Тасдиқланган',
      topRated: 'Топ рейтинг',

      // Специализации
      specFamily: 'Оила ҳуқуқи',
      specCriminal: 'Жиноят ҳуқуқи',
      specCivil: 'Фуқаролик ҳуқуқи',
      specBusiness: 'Бизнес ҳуқуқи',
      specLabor: 'Меҳнат ҳуқуқи',
      specProperty: 'Кўчмас мулк',
      specTax: 'Солиқ ҳуқуқи',
      specIntellectual: 'Интеллектуал мулк',
    },
    en: {
      title: 'Lawyers',
      subtitle: 'Find the right specialist',
      searchPlaceholder: 'Search by name or specialization...',
      filters: 'Filters',
      specialization: 'Specialization',
      experience: 'Experience',
      rating: 'Rating',
      price: 'Price',
      from: 'from',
      years: 'years',
      consultations: 'consultations',
      reviews: 'reviews',
      bookConsultation: 'Book',
      viewProfile: 'Profile',
      online: 'Online',
      offline: 'Offline',
      verified: 'Verified',
      topRated: 'Top rated',

      // Специализации
      specFamily: 'Family Law',
      specCriminal: 'Criminal Law',
      specCivil: 'Civil Law',
      specBusiness: 'Business Law',
      specLabor: 'Labor Law',
      specProperty: 'Real Estate',
      specTax: 'Tax Law',
      specIntellectual: 'Intellectual Property',
    },
  },

  // ==================== КОНСУЛЬТАЦИИ ====================
  consultations: {
    ru: {
      title: 'Консультации',
      myConsultations: 'Мои консультации',
      upcoming: 'Предстоящие',
      past: 'Прошедшие',
      status: 'Статус',
      date: 'Дата',
      time: 'Время',
      lawyer: 'Юрист',
      client: 'Клиент',
      topic: 'Тема',
      description: 'Описание',

      // Статусы
      statusPending: 'Ожидает',
      statusAccepted: 'Принято',
      statusRejected: 'Отклонено',
      statusCompleted: 'Завершено',
      statusCancelled: 'Отменено',

      // Действия
      accept: 'Принять',
      reject: 'Отклонить',
      cancel: 'Отменить',
      reschedule: 'Перенести',
      startCall: 'Начать звонок',
      joinCall: 'Присоединиться',
      leaveReview: 'Оставить отзыв',

      // Бронирование
      bookingTitle: 'Запрос на консультацию',
      selectDate: 'Выберите дату',
      selectTime: 'Выберите время',
      yourQuestion: 'Ваш вопрос',
      additionalInfo: 'Дополнительная информация',
      consultationType: 'Тип консультации',
      videoCall: 'Видео-консультация',
      chatConsultation: 'Чат-консультация',
      sendRequest: 'Отправить запрос',
      requestSent: 'Запрос отправлен юристу! Ожидайте подтверждения.',

      // Сообщения
      noConsultations: 'У вас пока нет консультаций',
      bookFirst: 'Запишитесь на первую консультацию',
    },
    uz: {
      title: 'Консультациялар',
      myConsultations: 'Менинг консультацияларим',
      upcoming: 'Келажак',
      past: 'Ўтган',
      status: 'Ҳолат',
      date: 'Сана',
      time: 'Вақт',
      lawyer: 'Юрист',
      client: 'Мижоз',
      topic: 'Мавзу',
      description: 'Тавсиф',

      // Статусы
      statusPending: 'Кутилмоқда',
      statusAccepted: 'Қабул қилинди',
      statusRejected: 'Рад этилди',
      statusCompleted: 'Тугалланди',
      statusCancelled: 'Бекор қилинди',

      // Действия
      accept: 'Қабул қилиш',
      reject: 'Рад этиш',
      cancel: 'Бекор қилиш',
      reschedule: 'Қайта режалаштириш',
      startCall: 'Қўнғироқни бошлаш',
      joinCall: 'Қўшилиш',
      leaveReview: 'Фикр қолдириш',

      // Бронирование
      bookingTitle: 'Консультация сўрови',
      selectDate: 'Санани танланг',
      selectTime: 'Вақтни танланг',
      yourQuestion: 'Саволингиз',
      additionalInfo: 'Қўшимча маълумот',
      consultationType: 'Консультация тури',
      videoCall: 'Видео-консультация',
      chatConsultation: 'Чат-консультация',
      sendRequest: 'Сўров юбориш',
      requestSent: 'Сўров юристга юборилди! Тасдиқни кутинг.',

      // Сообщения
      noConsultations: 'Сизда ҳали консультациялар йўқ',
      bookFirst: 'Биринчи консультацияга ёзилинг',
    },
    en: {
      title: 'Consultations',
      myConsultations: 'My consultations',
      upcoming: 'Upcoming',
      past: 'Past',
      status: 'Status',
      date: 'Date',
      time: 'Time',
      lawyer: 'Lawyer',
      client: 'Client',
      topic: 'Topic',
      description: 'Description',

      // Статусы
      statusPending: 'Pending',
      statusAccepted: 'Accepted',
      statusRejected: 'Rejected',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',

      // Действия
      accept: 'Accept',
      reject: 'Reject',
      cancel: 'Cancel',
      reschedule: 'Reschedule',
      startCall: 'Start call',
      joinCall: 'Join call',
      leaveReview: 'Leave review',

      // Бронирование
      bookingTitle: 'Consultation request',
      selectDate: 'Select date',
      selectTime: 'Select time',
      yourQuestion: 'Your question',
      additionalInfo: 'Additional information',
      consultationType: 'Consultation type',
      videoCall: 'Video consultation',
      chatConsultation: 'Chat consultation',
      sendRequest: 'Send request',
      requestSent: 'Request sent to the lawyer! Please wait for confirmation.',

      // Сообщения
      noConsultations: 'You have no consultations yet',
      bookFirst: 'Book your first consultation',
    },
  },

  // ==================== ДОКУМЕНТЫ ====================
  documents: {
    ru: {
      title: 'Документы',
      myDocuments: 'Мои документы',
      upload: 'Загрузить',
      uploadDocument: 'Загрузить документ',
      dragDrop: 'Перетащите файл сюда или нажмите для выбора',
      supportedFormats: 'Поддерживаемые форматы: PDF, DOC, DOCX, JPG, PNG',
      maxSize: 'Максимальный размер: 10 МБ',
      analyze: 'Анализировать',
      download: 'Скачать',
      delete: 'Удалить',
      fileName: 'Название файла',
      fileSize: 'Размер',
      uploadDate: 'Дата загрузки',
      status: 'Статус',

      // AI анализ
      aiAnalysis: 'AI Анализ документа',
      analyzing: 'Анализируем документ...',
      analysisComplete: 'Анализ завершен',
      riskLevel: 'Уровень риска',
      recommendations: 'Рекомендации',
      keyPoints: 'Ключевые моменты',

      // Статусы
      statusUploaded: 'Загружен',
      statusAnalyzing: 'Анализируется',
      statusAnalyzed: 'Проанализирован',
      statusError: 'Ошибка',
    },
    uz: {
      title: 'Ҳужжатлар',
      myDocuments: 'Менинг ҳужжатларим',
      upload: 'Юклаш',
      uploadDocument: 'Ҳужжат юклаш',
      dragDrop: 'Файлни шу ерга ташланг ёки танлаш учун босинг',
      supportedFormats: 'Қўллаб-қувватланадиган форматлар: PDF, DOC, DOCX, JPG, PNG',
      maxSize: 'Максимал ҳажм: 10 МБ',
      analyze: 'Таҳлил қилиш',
      download: 'Юклаб олиш',
      delete: 'Ўчириш',
      fileName: 'Файл номи',
      fileSize: 'Ҳажми',
      uploadDate: 'Юкланган сана',
      status: 'Ҳолат',

      // AI анализ
      aiAnalysis: 'AI Ҳужжат таҳлили',
      analyzing: 'Ҳужжат таҳлил қилинмоқда...',
      analysisComplete: 'Таҳлил тугалланди',
      riskLevel: 'Хавф даражаси',
      recommendations: 'Тавсиялар',
      keyPoints: 'Асосий нуқталар',

      // Статусы
      statusUploaded: 'Юкланди',
      statusAnalyzing: 'Таҳлил қилинмоқда',
      statusAnalyzed: 'Таҳлил қилинди',
      statusError: 'Хатолик',
    },
    en: {
      title: 'Documents',
      myDocuments: 'My documents',
      upload: 'Upload',
      uploadDocument: 'Upload document',
      dragDrop: 'Drag and drop file here or click to select',
      supportedFormats: 'Supported formats: PDF, DOC, DOCX, JPG, PNG',
      maxSize: 'Maximum size: 10 MB',
      analyze: 'Analyze',
      download: 'Download',
      delete: 'Delete',
      fileName: 'File name',
      fileSize: 'Size',
      uploadDate: 'Upload date',
      status: 'Status',

      // AI анализ
      aiAnalysis: 'AI Document Analysis',
      analyzing: 'Analyzing document...',
      analysisComplete: 'Analysis complete',
      riskLevel: 'Risk level',
      recommendations: 'Recommendations',
      keyPoints: 'Key points',

      // Статусы
      statusUploaded: 'Uploaded',
      statusAnalyzing: 'Analyzing',
      statusAnalyzed: 'Analyzed',
      statusError: 'Error',
    },
  },

  // ==================== AI ЧАТ ====================
  ai: {
    ru: {
      title: 'AI Помощник',
      subtitle: 'Бесплатная юридическая консультация',
      placeholder: 'Задайте ваш юридический вопрос...',
      send: 'Отправить',
      voiceInput: 'Голосовой ввод',
      recording: 'Запись...',
      thinking: 'AI думает...',
      newChat: 'Новый чат',
      history: 'История чатов',
      clearHistory: 'Очистить историю',

      // Подсказки
      suggestions: 'Часто задаваемые вопросы:',
      suggestion1: 'Как оформить развод?',
      suggestion2: 'Права при увольнении',
      suggestion3: 'Как вернуть товар?',
      suggestion4: 'Регистрация бизнеса',

      // Сообщения
      welcome: 'Здравствуйте! Я AI-помощник MaslaXat. Задайте мне любой юридический вопрос, и я постараюсь помочь.',
      disclaimer: 'Обратите внимание: AI-консультация носит информационный характер и не заменяет консультацию с профессиональным юристом.',
    },
    uz: {
      title: 'AI Ёрдамчи',
      subtitle: 'Бепул юридик консультация',
      placeholder: 'Юридик саволингизни ёзинг...',
      send: 'Юбориш',
      voiceInput: 'Овозли киритиш',
      recording: 'Ёзиб олинмоқда...',
      thinking: 'AI ўйламоқда...',
      newChat: 'Янги чат',
      history: 'Чатлар тарихи',
      clearHistory: 'Тарихни тозалаш',

      // Подсказки
      suggestions: 'Кўп бериладиган саволлар:',
      suggestion1: 'Ажрашишни қандай расмийлаштириш?',
      suggestion2: 'Ишдан бўшатилгандаги ҳуқуқлар',
      suggestion3: 'Маҳсулотни қандай қайтариш?',
      suggestion4: 'Бизнесни рўйхатдан ўтказиш',

      // Сообщения
      welcome: 'Ассалому алайкум! Мен МаслаХатнинг AI-ёрдамчисиман. Менга ҳар қандай юридик савол беринг, мен ёрдам беришга ҳаракат қиламан.',
      disclaimer: 'Эътибор беринг: AI-консультация ахборот характерига эга ва профессионал юрист билан маслаҳатлашишни алмаштирмайди.',
    },
    en: {
      title: 'AI Assistant',
      subtitle: 'Free legal consultation',
      placeholder: 'Ask your legal question...',
      send: 'Send',
      voiceInput: 'Voice input',
      recording: 'Recording...',
      thinking: 'AI is thinking...',
      newChat: 'New chat',
      history: 'Chat history',
      clearHistory: 'Clear history',

      // Подсказки
      suggestions: 'Frequently asked questions:',
      suggestion1: 'How to file for divorce?',
      suggestion2: 'Rights when fired',
      suggestion3: 'How to return a product?',
      suggestion4: 'Business registration',

      // Сообщения
      welcome: 'Hello! I am MaslaXat AI assistant. Ask me any legal question and I will try to help.',
      disclaimer: 'Please note: AI consultation is for informational purposes only and does not replace consultation with a professional lawyer.',
    },
  },

  // ==================== ПРОФИЛЬ ====================
  profile: {
    ru: {
      title: 'Профиль',
      personalInfo: 'Личная информация',
      firstName: 'Имя',
      lastName: 'Фамилия',
      email: 'Email',
      phone: 'Телефон',
      address: 'Адрес',
      city: 'Город',
      changePhoto: 'Изменить фото',
      changePassword: 'Изменить пароль',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      confirmPassword: 'Подтвердите пароль',
      saveChanges: 'Сохранить изменения',
      profileUpdated: 'Профиль успешно обновлен',
    },
    uz: {
      title: 'Профил',
      personalInfo: 'Шахсий маълумотлар',
      firstName: 'Исм',
      lastName: 'Фамилия',
      email: 'Электрон почта',
      phone: 'Телефон',
      address: 'Манзил',
      city: 'Шаҳар',
      changePhoto: 'Расмни ўзгартириш',
      changePassword: 'Паролни ўзгартириш',
      currentPassword: 'Жорий парол',
      newPassword: 'Янги парол',
      confirmPassword: 'Паролни тасдиқланг',
      saveChanges: 'Ўзгаришларни сақлаш',
      profileUpdated: 'Профил муваффақиятли янгиланди',
    },
    en: {
      title: 'Profile',
      personalInfo: 'Personal information',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      city: 'City',
      changePhoto: 'Change photo',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      saveChanges: 'Save changes',
      profileUpdated: 'Profile updated successfully',
    },
  },

  // ==================== НАСТРОЙКИ ====================
  settings: {
    ru: {
      title: 'Настройки',
      language: 'Язык',
      theme: 'Тема',
      themeLight: 'Светлая',
      themeDark: 'Темная',
      themeAuto: 'Авто',
      notifications: 'Уведомления',
      emailNotifications: 'Email уведомления',
      pushNotifications: 'Push уведомления',
      smsNotifications: 'SMS уведомления',
      privacy: 'Конфиденциальность',
      showProfile: 'Показывать профиль',
      showActivity: 'Показывать активность',
    },
    uz: {
      title: 'Созламалар',
      language: 'Тил',
      theme: 'Мавзу',
      themeLight: 'Оч ранг',
      themeDark: 'Тўқ ранг',
      themeAuto: 'Автоматик',
      notifications: 'Билдиришномалар',
      emailNotifications: 'Email билдиришномалар',
      pushNotifications: 'Push билдиришномалар',
      smsNotifications: 'SMS билдиришномалар',
      privacy: 'Махфийлик',
      showProfile: 'Профилни кўрсатиш',
      showActivity: 'Фаолликни кўрсатиш',
    },
    en: {
      title: 'Settings',
      language: 'Language',
      theme: 'Theme',
      themeLight: 'Light',
      themeDark: 'Dark',
      themeAuto: 'Auto',
      notifications: 'Notifications',
      emailNotifications: 'Email notifications',
      pushNotifications: 'Push notifications',
      smsNotifications: 'SMS notifications',
      privacy: 'Privacy',
      showProfile: 'Show profile',
      showActivity: 'Show activity',
    },
  },

  // ==================== ЮРИСТ ДАШБОРД ====================
  lawyerDashboard: {
    ru: {
      title: 'Панель юриста',
      newRequests: 'Новые заявки',
      activeClients: 'Активные клиенты',
      completedToday: 'Завершено сегодня',
      totalEarnings: 'Общий доход',
      schedule: 'Расписание',
      todaySchedule: 'Расписание на сегодня',
      noAppointments: 'Нет записей на сегодня',
      pendingRequests: 'Ожидающие заявки',
      clientInfo: 'Информация о клиенте',
      acceptRequest: 'Принять',
      declineRequest: 'Отклонить',
    },
    uz: {
      title: 'Юрист панели',
      newRequests: 'Янги аризалар',
      activeClients: 'Фаол мижозлар',
      completedToday: 'Бугун тугалланган',
      totalEarnings: 'Умумий даромад',
      schedule: 'Жадвал',
      todaySchedule: 'Бугунги жадвал',
      noAppointments: 'Бугунга ёзувлар йўқ',
      pendingRequests: 'Кутилаётган аризалар',
      clientInfo: 'Мижоз маълумотлари',
      acceptRequest: 'Қабул қилиш',
      declineRequest: 'Рад этиш',
    },
    en: {
      title: 'Lawyer Dashboard',
      newRequests: 'New requests',
      activeClients: 'Active clients',
      completedToday: 'Completed today',
      totalEarnings: 'Total earnings',
      schedule: 'Schedule',
      todaySchedule: "Today's schedule",
      noAppointments: 'No appointments today',
      pendingRequests: 'Pending requests',
      clientInfo: 'Client information',
      acceptRequest: 'Accept',
      declineRequest: 'Decline',
    },
  },

  // ==================== АДМИН ПАНЕЛЬ ====================
  adminDashboard: {
    ru: {
      title: 'Админ панель',
      totalUsers: 'Всего пользователей',
      totalLawyers: 'Всего юристов',
      totalConsultations: 'Всего консультаций',
      revenue: 'Доход',
      userManagement: 'Управление пользователями',
      lawyerManagement: 'Управление юристами',
      verifyLawyer: 'Верифицировать',
      blockUser: 'Заблокировать',
      unblockUser: 'Разблокировать',
      specializations: 'Специализации',
      addSpecialization: 'Добавить специализацию',
      analytics: 'Аналитика',
      reports: 'Отчеты',
    },
    uz: {
      title: 'Админ панели',
      totalUsers: 'Жами фойдаланувчилар',
      totalLawyers: 'Жами юристлар',
      totalConsultations: 'Жами консультациялар',
      revenue: 'Даромад',
      userManagement: 'Фойдаланувчиларни бошқариш',
      lawyerManagement: 'Юристларни бошқариш',
      verifyLawyer: 'Тасдиқлаш',
      blockUser: 'Блоклаш',
      unblockUser: 'Блокдан чиқариш',
      specializations: 'Ихтисосликлар',
      addSpecialization: 'Ихтисослик қўшиш',
      analytics: 'Таҳлил',
      reports: 'Ҳисоботлар',
    },
    en: {
      title: 'Admin Dashboard',
      totalUsers: 'Total users',
      totalLawyers: 'Total lawyers',
      totalConsultations: 'Total consultations',
      revenue: 'Revenue',
      userManagement: 'User management',
      lawyerManagement: 'Lawyer management',
      verifyLawyer: 'Verify',
      blockUser: 'Block',
      unblockUser: 'Unblock',
      specializations: 'Specializations',
      addSpecialization: 'Add specialization',
      analytics: 'Analytics',
      reports: 'Reports',
    },
  },
};

export default translations;
